export default __webpack_public_path__ + "static/media/5757473.89175e50.jpg";